import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import useChart from '../../hooks/useChart';
import { getScoreChartOptions } from './data/chart-score';

const ScoreChart = ({ gameExplorerReport, factor }) => {
  const options = useMemo(
    () => getScoreChartOptions(gameExplorerReport, factor),
    [gameExplorerReport, factor],
  );
  const domRef = useChart(options);

  return (
    <div>
      <div className="s-game-explorer__score" ref={domRef} />
    </div>
  );
};

ScoreChart.propTypes = {
  gameExplorerReport: PropTypes.object.isRequired,
};

export default ScoreChart;
